import "./cloud.scss"

function Cloud(){
    return(
        <>
            <div className="cloud-main"></div>
            <div className="cloud-center"></div>
            <div className="cloud-left"></div>
            </>
    )
}

export default Cloud;